<template>
  <div class="mt-3">
    <icon-view
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-user text-orange"
      title="Seleccione Rol(es) para ver mensaje"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      :gradient="true"
    />
    <div class="row">
      <div class="col-12">
        <user-role-selection
          :role-list="roles"
          :selected-roles="model.roles"
          :show-error="rolSelectorErrorIndicator"
          :show-user-selection="false"
          :readOnly="readOnly"
          @on-select-rol="onSelect"
          @on-unselect-role="onUnSelectRole"
          @on-unselect-all="onUnSelectAll"
          @on-change-rol="onChangeRol"
        />
      </div>
    </div>

    <icon-view
      class="mr-2 mt-5 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-user text-orange"
      title="Seleccione Usuario(s) para ver mensaje"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      :gradient="true"
    />
    <div class="row">
      <div class="col-12">
        <user-role-selection
          :role-list="roles"
          :user-list="users"
          :selected-users="model.users"
          :show-error="rolSelectorErrorIndicator"
          :readOnly="readOnly"
          @on-select-rol="onSelect"
          @on-select-user="onSelectUser"
          @on-unselect-user="onUnSelectUser"
          @on-unselect-role="onUnSelectRole"
          @on-unselect-all="onUnSelectAll"
          @on-change-rol="onChangeRol"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconView from "icon-view";
import UserRoleSelection from "@/components/common/UserRoleSelection";
import {
  getterTypes,
  actionTypes
} from "@/modules/operation-message/store/types";
import alertMixin from "@/mixin/alert.mixin";
import { modulesName } from "@/modules";
const { mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.operationMessageModuleName
);
import { createNamespacedHelpers } from "vuex";
import service from "@/modules/operation-calendar-event/api";

export default {
  name: "DashboardMaintenance",
  mixins: [alertMixin],
  components: {
    IconView,
    UserRoleSelection
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    readOnly:{
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      rolSelectorErrorIndicator: false,
      users: []
    };
  },
  async mounted() {
    await this.getAuthTypes();
  },
  mounted() {
    const { isEditMode, id } = this.$route.params;
    if (isEditMode) {
      this.isEditMode = isEditMode;
      this.messageIdToEdit = id;

      this.loadMessage(id);
    }
    this[actionTypes.FETCH_ROL]();
    this[actionTypes.FETCH_LOCATION]();
    this[actionTypes.FETCH_APPLICATION]();
  },
  computed: {
    ...mapGetters({
      locations: getterTypes.GET_LOCATION,
      roles: getterTypes.GET_ROL,
      currentFilters: getterTypes.GET_CURRENT_FILTER
    }),
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    minDate() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    isCodeInputvisible() {
      return this.model.auth.methodId == AUTH_METHODS.Code;
    }
  },
  methods: {
    ...mapActions([
      actionTypes.FETCH_MESSAGE_BY_ID,
      actionTypes.SAVE_CHANGES,
      actionTypes.FETCH_RESULT,
      actionTypes.FETCH_APPLICATION,
      actionTypes.FETCH_LOCATION,
      actionTypes.FETCH_ROL
    ]),
    ...mapGetters([getterTypes.GET_APPLICATION]),
    onSelect(isAll, item) {
      if (!isAll && item) {
        this.model.roles.push(item);
      }
      if (isAll) {
        item.forEach(i => {
          this.model.roles.push(i);
        });
      }
    },
    onSelectUser(isAll, item) {
      if (!isAll && item) {
        this.model.users.push(item);
      }
      if (isAll) {
        item.forEach(i => {
          this.model.users.push(i);
        });
      }
    },
    onUnSelectRole(item) {
      if (item && item.id) {
        this.model.roles = this.model.roles.filter(x => x.id !== item.id);
      }
    },
    onUnSelectUser(item) {
      if (item && item.id) {
        this.model.users = this.model.users.filter(x => x.id !== item.id);
      }
    },
    onUnSelectAll(inUserSlectionMode) {
      if (inUserSlectionMode) {
        this.model.users = [];
      } else {
        this.model.roles = [];
      }
    },
    async onChangeRol(item) {
      if (!item) {
        this.users = [];
        return;
      }
      await service
        .fetchUsers(item.id)
        .then(res => {
          this.users = res.data;
        })
        .catch(error => {
          this.ShowToast("", error.data.errors.errors[0], "error");
        });
    },
    validate() {
      return !this.verifyAddedRoles();
    },
    verifyAddedRoles() {
      let viewErrorIndicator = false;
      this.rolSelectorErrorIndicator = viewErrorIndicator =
        this.model.roles.length == 0 && this.model.users.length == 0;

      return viewErrorIndicator;
    }
  }
};
</script>

<style scoped>
::v-deep(.fa-calendar-day) {
  font-weight: 400 !important;
}
::v-deep(.dot.text-center) {
  background-color: white !important;
}
::v-deep(.custom-datetime-picker-container.width-container) {
  width: 31.8% !important;
}
.custom-checkbox {
  appearance: none; /* Elimina el estilo predeterminado */
  width: 25px;
  height: 25px;
  border-radius: 50%; /* Hace que el checkbox sea circular */
  border: 2px solid #4caf50; /* Borde verde */
  background-color: white; /* Fondo blanco */
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  border-color: #d6d6d6; /* Borde verde cuando está marcado */
}

/* Estilo cuando el checkbox está marcado */
.custom-checkbox:checked {
  background-color: #30b484; /* Fondo verde cuando está marcado */
  border-color: #fff; /* Borde verde cuando está marcado */
}

/* Estilo para mostrar el checkmark */
.custom-checkbox:checked::after {
  content: "✔"; /* Checkmark */
  color: white;
  font-size: 14px;
  position: absolute;
  left: 5px;
}
.custom-space {
  right: 4px;
}
</style>
